import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'
import { pdfLabelSetRepository } from '@webapp/modules/vendor/data-access/repositories/PDFLabelSetRepository' // eslint-disable-line import/no-internal-modules
import { type PDFLabelSet } from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules
import { pdfLabelSetQueryConfig } from '@webapp/modules/vendor/query-configs/pdf-label-set' // eslint-disable-line import/no-internal-modules

export interface SetDefaultPOPDFLabelSetParams {
  labelSet: PDFLabelSet
  currentPrimaryKey: string | null
}

export const useMutateSetDefaultPOPDFLabelSet = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, SetDefaultPOPDFLabelSetParams>({
    mutationFn: ({
      labelSet,
      currentPrimaryKey,
    }: SetDefaultPOPDFLabelSetParams) => {
      // BHV-039 delegation: no primary yet → POST; clicking the current
      // default → DELETE (clears); otherwise → PUT (changes the primary)
      if (!currentPrimaryKey) {
        return pdfLabelSetRepository.setPrimary(labelSet.key)
      }

      if (labelSet.key === currentPrimaryKey) {
        return pdfLabelSetRepository.clearPrimary()
      }

      return pdfLabelSetRepository.updatePrimary(labelSet.key)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: pdfLabelSetQueryConfig.all().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: poPdfLabelEditorQueryConfig.initialSet().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
